module.exports = __webpack_public_path__ + "img/gotv.548765dc.svg";